import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { CHECKOUT } from '~/scopes/checkout/routes-names'
import { useCartStore } from '~/scopes/checkout/stores/cartStore'

// As per nuxt documentation we should not return anything or return undefined if we do not want to alter the redirection.
// https://nuxt.com/docs/guide/directory-structure/middleware
// eslint-disable-next-line consistent-return
export default defineNuxtRouteMiddleware(async (to) => {
  const cartStore = useCartStore()
  const logger = useLogger()
  const experiments = useExperiments()

  if (
    experiments['experiment.deliveryMethodPosition'] ===
      'shippingDeliveryMethod' &&
    to.name === CHECKOUT.ADDRESS_CONFIRMATION
  ) {
    return true
  }

  // We don't want to fire the request each time this middleware is instantiated.
  // If the cart was already fetched, there is no need to fetch it
  // again, and we should use the data saved in our store.
  if (!cartStore.isCartLoaded) {
    await cartStore.fetchCart()
  }

  if (cartStore.isSelectedCollectionPointMissing) {
    logger.info('[CHECKOUT][MIDDLEWARE] No selected collection point', {
      isCartLoaded: cartStore.isCartLoaded,
      cartItems: cartStore.items,
    })

    return navigateTo({ name: CHECKOUT.CART })
  }
})
